import React, {useCallback, useEffect, useState} from 'react'
import style from './connect.module.scss';
import { LmLoader, useToggleState } from '@mes-ui/lemma';
import {isEmpty} from "lodash";
import {getCookie} from "../../utils/cookie";
import axios from "axios";
import { MaxModal } from "../../components/MaxModal";
import API from "../../API";
import {Helmet} from "react-helmet";

const CODE_MAX = 'max';

function ConnectMaxView() {

    const authData = getCookie('aupd_token');
    const empty = isEmpty(authData);
    const [open, setOpen] = useToggleState(true);
    const [connectCheckLoading, setConnectCheckLoading] = useToggleState(false);
    const [isConnectMax, setIsConnectMax] = useToggleState(false);

    const [zoomDisabled, setZoomDisabled] = useState(true);

    const [userLoading, setUserLoading] = useState(false);
    const [user, setUser] = useState(null);

    const handleGetPartners = useCallback((checkUrl = false) => {
        API.getExternalPartners().then((list= []) => {
            const isConnectMax = list?.find((item) => item.code === CODE_MAX)?.userData?.externalId || false;
            setIsConnectMax(isConnectMax);
            setConnectCheckLoading(false);
        }).catch(() => {
            setConnectCheckLoading(false);
        });
    }, []);

    const getAuthTokens = async () => {
        setUserLoading(true);
        try {
            const userinfo = await axios.get('/v3/userinfo', { headers: { Authorization: `Bearer ${authData}` }})
            const { data, status } = userinfo;

            switch (status) {
                case 201:
                case 200:
                    setUser(data);
                    setUserLoading(false);
                    handleGetPartners();
                    break;
                case 404:
                    setUser(null);
                    setUserLoading(false);
                    break
                default:
                    setUser(null);
                    setUserLoading(false);
            }
        } catch (e) {
            setUserLoading(false);
        }
    };

    const handlerCloseMax = () => {
        setOpen(false);
    }

    const handleOpenDone = () => {}

    useEffect(() => {
        setZoomDisabled(true);

        if (!empty) {
            getAuthTokens();
        }

        return () => {
            setZoomDisabled(false);
        }
    }, [empty, setZoomDisabled])

    // if (empty) {
    //     return null;
    // }

    return (
        <>
            <Helmet>
                <meta
                    name="viewport"
                    content={
                        zoomDisabled
                            ? "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
                            : "width=device-width, initial-scale=1"
                    }
                />
            </Helmet>
            <div className={style.Content}>

                {userLoading ? <LmLoader color={'gray'} description="" title="Загрузка данных пользователя" view="page" /> : (
                    <>
                        <MaxModal
                            user={user}
                            openMax={open}
                            onCloseMax={handlerCloseMax}
                            onOpenDone={handleOpenDone}
                            mobile
                            loadingConnect={connectCheckLoading}
                            isConnectMax={isConnectMax} />
                    </>
                )}
            </div>
        </>
    )
}

export default ConnectMaxView
